<template>
  <div class="order-item-warp" @click="orderDetails">
    <div class="order-item-banner" :style="item.pshopLogo ? `background-image:url(${item.pshopLogo});` : ''" >
    </div>
    <div class="order-item-title">
      <span>{{ item.pShopName }}</span>
      <div class="order-item-state" :class="{'order-item-state-theme': item.pZujie === 1}">{{typeMap[item.pZujie]}}</div>
    </div>
    <div class="order-item-info">
      <span>{{ orderDuration(item) }}</span>
      <span>{{item.pcurrencyName}} {{$moneyFormat(item.pJiesuan)}}</span>
    </div>
    <div class="order-item-date">{{ formatDate(item.borrowTime) }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import i18n from "../../i18n";
import dayjs from "dayjs"
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["locale"]),
    i18n() {
      return this.$t("order_item")
    },
    isZujie() {
      return (
        this.item.pJiesuanid === 0 &&
        (this.item.pZujie === 1 || this.item.pZujie === 4)
      )
    },
    currencyName () {
      return this.item.pCurrencyName || this.locale.money
    }
  },
  data() {
    return {
      typeMap: {}
    }
  },
  methods: {
    onSubmit() {
      this.$router.push({
        path: "/confirm",
        query: {
          price: this.item.pJiesuan,
          payType: "FK",
          outTradeNo: this.item.pOrderid,
          cabinetID: this.item.pCabinetid
        }
      })
    },
    // 订单详情
    orderDetails() {
      this.$router.push(`/order/${this.item.porderid}`)
    },
    // 格式化时间
    orderDateFmt(seconds = 0) {
      let hours = Number.parseInt(seconds / 3600)
      let minutes = Number.parseInt((seconds - hours * 3600) / 60)
      let second = Number.parseInt(seconds - hours * 3600 - minutes * 60)
      second = second < 10 ? "0" + second : second
      hours = hours < 10 ? "0" + hours : hours
      minutes = minutes < 10 ? "0" + minutes : minutes
      return `${hours}:${minutes}:${second}`
    },
    // 订单时长
    orderDuration(order) {
      let seconds = order.puseMins * 60
      if (order.puseMins === 0 && order.pZujie === 1) {
        const nT = Date.now()
        const bT = new Date(this.$dateFmt(order.pborrowtime)).getTime()
        seconds = parseInt((nT - bT) / 1000)
      }
      return this.orderDateFmt(seconds || 0)
    },
    formatDate(val) {
      const date = dayjs(val);
      const dayOfWeek = date.format('ddd');
      const day = date.date();
      const month = date.format('MMMM');
      const year = date.format('YYYY');

      const suffix = this.getOrdinalSuffix(day);

      return `${dayOfWeek}. ${day}${suffix} ${month} ${year}`;
    },
    getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }
  },
  created() {
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      5: this.i18n.type_5
    }
  }
}
</script>

<style lang="less" scoped>
.order-item-warp + .order-item-warp {
  margin-top: 40px;
}
.order-item-warp {
  background-color: #fff;
  padding: 35px 35px 25px;
  border-radius: 28px;
  color: #000;
  font-size: 28px;
  font-family: 'Montserrat-Regular';
  .order-item-banner {
    position: relative;
    height: 203px;
    margin-bottom: 18px;
    background-color: #F8F6FC;
    border-radius: 18px;
    background-image: url('../../assets/imgs/banner-home.jpg');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .order-item-title {
    display: flex;
    padding: 24px 0 8px;
    align-items: center;
    .order-item-state {
      background: #E5E4E6;
      color: #959595;
      padding: 7px 18px;
      border-radius: 14px;
      margin-left: 20px;
    }
    .order-item-state-theme {
      background: rgba(255, 202, 14, 0.15);
      color: #FFCA0E;
    }
  }
  .order-item-info {
    font-size: 53px;
    color: #FFCA0E;
    display: flex;
    justify-content: space-between;
  }
  .order-item-date {
    color: rgba(0, 0, 0, 0.5);
  }
}
</style>
